import React, { Component } from "react";
import { Card, CardBody, Col, Row, Table } from "reactstrap";
import Tabs, { TabPane } from "rc-tabs";
import TabContent from "rc-tabs/lib/SwipeableTabContent";
import ScrollableInkTabBar from "rc-tabs/lib/ScrollableInkTabBar";
import { formatNumber } from "../../utils/utils";
import CustomSpinner from "../../components/CustomSpinner/CustomSpinner";
import PrimaryOfftakeSummary from "./primaryOfftakeSummary";

import { messages } from "../../constants/constant.message";
import moment from "moment";
import { Roles } from "../../constants/constant.role";
const { NO_OFFTAKE_SUMMARY } = messages.REPORT;

class TruckBusPointsReports extends Component {
  state = {
    year: null,
    // loading: this.props && this.props.loading
  };
  months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  getStripedStyle(index) {
    return { background: index % 2 === 0 ? "#f6f6f6" : "white" };
  }
  getQuarter = (month) => {
    var m = Math.floor(month / 3) + 2;
    return m > 4 ? m - 4 : m;
  };

  componentWillReceiveProps(props) {
    if (props.year) {
      this.setState({
        year: props.year,
      });
    }
  }

  render() {
    const { memberRole, memberType, totals, labels, loading } = this.props;
    let truckBusPoints = this.props.truckBusPoints;
    let offTakeSummary = this.props.offTakeSummary;
    let currnetMonth = this.months[new Date().getMonth()];
    let memberRoleFinal =
      memberType === Roles.FLEET_ROLE ? Roles.FLEET_ROLE : memberRole;
    return (
      <>
        {loading && <CustomSpinner />}
        {memberRoleFinal &&
        [
          Roles.HEAD_OFFICE_BAADSHAH_ROLE,
          Roles.PROJECT_MANAGER_ROLE,
          Roles.FLEET_MANAGER_ROLE,
          Roles.ZONAL_FLEET_MANAGER_ROLE,
        ].includes(memberRoleFinal) === true ? (
          <Row>
            <Col xl="8" lg="8" className="pr-0">
              <>
                {!loading && truckBusPoints.length > 0
                  ? truckBusPoints.map((quarter, i) => (
                      <div
                        className="quarter-points-wrapp quarterPointBlock mb-4"
                        key={"quarter-points" + i}
                      >
                        <div className="quarter-points-inner">
                          <span className="QUARTER-label">
                            QUARTER {quarter.quarter} ({quarter.month[0]}-
                            {quarter.month[quarter.month.length - 1]})&nbsp;
                            {quarter.month.map((item, monthIndex) =>
                              currnetMonth === item &&
                              new Date().getFullYear() <= this.state.year
                                ? "Current Quarter"
                                : ""
                            )}
                          </span>
                        </div>
                        <div className="QUARTER-tables">
                          <div
                            className="QUARTER-table quarter-tbl-left"
                            style={{ minWidth: "440px", flex: 1 }}
                          >
                            <div className="mb-1 Total-Offtake mb-2 d-flex flex-wrap earnPointTitle">
                              <div className="mr-1">
                                Total Earned Points
                                {quarter.month.map((item, monthIndex) =>
                                  currnetMonth === item &&
                                  new Date().getFullYear() <= this.state.year
                                    ? "**"
                                    : ""
                                )}{" "}
                                <b style={{ marginRight: "10px" }}>
                                  {totals &&
                                    totals[`q${quarter.quarter}`] &&
                                    totals[`q${quarter.quarter}`]["truck"] &&
                                    totals[`q${quarter.quarter}`]["truck"][
                                      "totalPoints"
                                    ] &&
                                    formatNumber(
                                      totals[`q${quarter.quarter}`]["truck"][
                                        "totalPoints"
                                      ]
                                    )}
                                </b>
                              </div>
                              {/* <div style={{ flex: 1, textAlign: 'right' }}>
                            Slab Jump Points {" "}
                            <b>{totals && totals[`q${quarter.quarter}`] && totals[`q${quarter.quarter}`]['truck'] && totals[`q${quarter.quarter}`]['truck']['slab_jump_points'] ?
                              formatNumber(totals[`q${quarter.quarter}`]['truck']['slab_jump_points']) : 0}</b>
                          </div> */}
                            </div>
                            <div className="mb-1 Total-Offtake mb-2 d-flex flex-wrap earnPointTitle">
                              <div className="mr-1">
                                Points on Offtake
                                <b style={{ marginLeft: "10px" }}>
                                  {totals &&
                                    totals[`q${quarter.quarter}`] &&
                                    totals[`q${quarter.quarter}`]["truck"] &&
                                    totals[`q${quarter.quarter}`]["truck"][
                                      "totalPoints"
                                    ] &&
                                    formatNumber(
                                      totals[`q${quarter.quarter}`]["truck"][
                                        "totalPoints"
                                      ] -
                                        +totals[`q${quarter.quarter}`]["truck"][
                                          "slab_jump_points"
                                        ]
                                    )}
                                </b>
                              </div>
                              <div style={{ flex: 1, marginLeft: "20px" }}>
                                Slab Jump Points{" "}
                                <b>
                                  {totals &&
                                  totals[`q${quarter.quarter}`] &&
                                  totals[`q${quarter.quarter}`]["truck"] &&
                                  totals[`q${quarter.quarter}`]["truck"][
                                    "slab_jump_points"
                                  ]
                                    ? formatNumber(
                                        totals[`q${quarter.quarter}`]["truck"][
                                          "slab_jump_points"
                                        ]
                                      )
                                    : 0}
                                </b>
                              </div>
                            </div>

                            {i === 0 &&
                              quarter.month &&
                              quarter.month.map((item, monthIndex) =>
                                currnetMonth === item &&
                                new Date().getFullYear() <= this.state.year ? (
                                  <span className="Till-Date mb-2 mt-0 cardNote">
                                    **Current quarter points are provisional
                                    points. They will get added to the yearly
                                    points at the end of current quarter based
                                    on the achievement of the minimum offtake
                                    criteria of the club.
                                  </span>
                                ) : (
                                  ""
                                )
                              )}
                            {totals &&
                            totals[`q${quarter.quarter}`] &&
                            totals[`q${quarter.quarter}`]["truck"] &&
                            totals[`q${quarter.quarter}`]["truck"][
                              "infoMessage"
                            ] &&
                            (totals[`q${quarter.quarter}`]["truck"][
                              "infoMessage"
                            ] !== null ||
                              totals[`q${quarter.quarter}`]["truck"][
                                "infoMessage"
                              ] !== "") ? (
                              // <div className="mb-2 mt-0 dangerText">Sorry! You have missed the minimum quarterly offtake target by (30) tyres, and hence not eligible for the quarterly points as per the points earn policy.</div>
                              <div className="mb-2 mt-0 dangerText">
                                {
                                  totals[`q${quarter.quarter}`]["truck"][
                                    "infoMessage"
                                  ]
                                }
                              </div>
                            ) : (
                              ""
                            )}
                            <Table
                              className="mb-0 table-responsive tbltruck-bus text-center"
                              bordered
                            >
                              <thead>
                                <tr style={{ ...this.getStripedStyle(0) }}>
                                  {labels &&
                                    labels.points &&
                                    labels.points.map((l) => <th>{l.key}</th>)}
                                </tr>
                              </thead>
                              <tbody>
                                {quarter.data.report.truck.map((item, i) => (
                                  <tr
                                    style={{ ...this.getStripedStyle(i + 1) }}
                                  >
                                    {labels &&
                                      labels.points &&
                                      labels.points.map((l) => (
                                        <td>
                                          {l.value === "month"
                                            ? this.months[item[l.value] - 1]
                                            : formatNumber(item[l.value])}
                                        </td>
                                      ))}
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                            <br />

                            {/* </div> */}
                          </div>
                          <div className="QUARTER-table" style={{ flex: 1 }}>
                            <span
                              className="mb-1 Total-Offtake mb-2 earnPointTitle"
                              style={{
                                marginTop: "25px",
                                minHeight: totals[`q${quarter.quarter}`][
                                  "truck"
                                ]["infoMessage"]
                                  ? "60px"
                                  : "auto",
                              }}
                            >
                              <span>Total Offtake</span>&nbsp;
                              <b>
                                {totals &&
                                  totals[`q${quarter.quarter}`] &&
                                  totals[`q${quarter.quarter}`]["truck"] &&
                                  totals[`q${quarter.quarter}`]["truck"][
                                    "totalOfftake"
                                  ] &&
                                  formatNumber(
                                    totals[`q${quarter.quarter}`]["truck"][
                                      "totalOfftake"
                                    ]
                                  )}
                              </b>
                              {/* <b>{formatNumber(quarter.truckOfftake)}</b> */}
                              {/* <span style={{ paddingLeft: '15px' }}>Total Eligible Offtake</span>&nbsp;
                          <b>{
                            totals && totals[`q${quarter.quarter}`] && totals[`q${quarter.quarter}`]['truck'] && totals[`q${quarter.quarter}`]['truck']['eligibleSales'] &&
                            formatNumber(totals[`q${quarter.quarter}`]['truck']['eligibleSales'])}</b> */}
                            </span>

                            {i === 0 &&
                              quarter.month &&
                              quarter.month.map((item, monthIndex) =>
                                currnetMonth === item &&
                                new Date().getFullYear() <= this.state.year ? (
                                  <>
                                    <span className="Till-Date mt-0 cardNote offtakeTableCardNote">
                                      Till{" "}
                                      {moment(new Date()).format("DD MMM YYYY")}
                                    </span>
                                    <span>&nbsp;</span>
                                  </>
                                ) : (
                                  ""
                                )
                              )}

                            <Table
                              className="mb-0 table-responsive tbltruck-bus text-center"
                              bordered
                            >
                              <thead>
                                <tr style={{ ...this.getStripedStyle(0) }}>
                                  {labels &&
                                    labels.offtake &&
                                    labels.offtake.map((l) => <th>{l.key}</th>)}
                                </tr>
                              </thead>
                              <tbody>
                                {quarter.data.report.truck.map((item, i) => (
                                  <tr
                                    key={i}
                                    style={{ ...this.getStripedStyle(i + 1) }}
                                  >
                                    {labels &&
                                      labels.offtake &&
                                      labels.offtake.map((l) => (
                                        <td>
                                          {l.value === "month"
                                            ? this.months[item[l.value] - 1]
                                            : formatNumber(item[l.value])}
                                        </td>
                                      ))}
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        </div>
                        {i === truckBusPoints.length - 1 && (
                          <>
                            <br />
                            {/* <a href="http://www.jktyrecrm.com" target="_blank">
                    <b className="Learn-more-about" style={{ color: "#495057" }}>
                      {messages.PRIMARY_REPORT.REDIRECT_JK_Baadshah}
                    </b>
                  </a> */}
                          </>
                        )}
                      </div>
                    ))
                  : // <CustomSpinner />
                    ""}
              </>
            </Col>
          </Row>
        ) : (
          <>
            <div>
              <Tabs
                defaultActiveKey="0"
                className="primary-report-tabs rc-tabs-top rc-tabs-nav-wrap"
                renderTabBar={() => (
                  <ScrollableInkTabBar extraContent={<></>} />
                )}
                renderTabContent={() => (
                  <TabContent style={{ paddingTop: "20px" }} />
                )}
              >
                {offTakeSummary &&
                offTakeSummary.pointsSummary &&
                offTakeSummary.pointsSummary.length > 0 ? (
                  <TabPane
                    tab="Points Summary"
                    key="1"
                    style={
                      this.props.from === "modal"
                        ? { overflowY: "auto", height: "67vh" }
                        : {}
                    }
                  >
                    {offTakeSummary &&
                      offTakeSummary.pointsSummary &&
                      offTakeSummary.pointsSummary.length > 0 && (
                        <>
                          <PrimaryOfftakeSummary
                            offTakeSummary={offTakeSummary}
                            totalEarnedPoints={offTakeSummary}
                          />
                        </>
                      )}
                    {!(
                      offTakeSummary &&
                      offTakeSummary.pointsSummary &&
                      offTakeSummary.pointsSummary.length > 0
                    ) && (
                      <>
                        <Card className="text-align-center">
                          <CardBody>{NO_OFFTAKE_SUMMARY}</CardBody>
                        </Card>
                      </>
                    )}
                  </TabPane>
                ) : (
                  ""
                )}
                <TabPane
                  tab="TBB & TBR"
                  key="0"
                  style={
                    this.props.from === "modal"
                      ? { overflowY: "auto", height: "67vh" }
                      : {}
                  }
                >
                  {!loading && truckBusPoints.length > 0
                    ? truckBusPoints.map((quarter, i) => {
                        return (
                          <Row>
                            <Col xl="8" lg="8" className="pr-0">
                              <div
                                className="quarter-points-wrapp quarterPointBlock mb-4"
                                key={"quarter-points" + i}
                              >
                                <div className="quarter-points-inner">
                                  <span className="QUARTER-label">
                                    QUARTER {quarter.quarter} (
                                    {quarter.month[0]}-
                                    {quarter.month[quarter.month.length - 1]}
                                    )&nbsp;
                                    {quarter.month.map((item, monthIndex) =>
                                      currnetMonth === item &&
                                      new Date().getFullYear() <=
                                        this.state.year
                                        ? "Current Quarter"
                                        : ""
                                    )}
                                  </span>
                                </div>
                                <div className="QUARTER-tables">
                                  <div
                                    className="QUARTER-table quarter-tbl-left"
                                    style={{ minWidth: "440px", flex: 1 }}
                                  >
                                    <div className="mb-1 Total-Offtake mb-2 d-flex flex-wrap earnPointTitle">
                                      <div className="mr-1">
                                        Total Earned points
                                        {quarter.month.map((item, monthIndex) =>
                                          currnetMonth === item &&
                                          new Date().getFullYear() <=
                                            this.state.year
                                            ? "**"
                                            : ""
                                        )}{" "}
                                        <b style={{ marginRight: "10px" }}>
                                          {totals &&
                                            totals[`q${quarter.quarter}`] &&
                                            totals[`q${quarter.quarter}`][
                                              "truck"
                                            ] &&
                                            totals[`q${quarter.quarter}`][
                                              "truck"
                                            ]["totalPoints"] &&
                                            formatNumber(
                                              totals[`q${quarter.quarter}`][
                                                "truck"
                                              ]["totalPoints"]
                                            )}
                                        </b>
                                      </div>
                                      {/* <div style={{ flex: 1, textAlign: 'right' }}>
                                    Slab Jump Points {" "}
                                    <b>{totals && totals[`q${quarter.quarter}`] && totals[`q${quarter.quarter}`]['truck'] && totals[`q${quarter.quarter}`]['truck']['slab_jump_points'] ?
                                      formatNumber(totals[`q${quarter.quarter}`]['truck']['slab_jump_points']) : 0}</b>
                                  </div> */}
                                    </div>
                                    <div>
                                      <div className="mb-1 Total-Offtake mb-2 d-flex flex-wrap earnPointTitle">
                                        <div className="mr-1">
                                          Points on Offtake
                                          <b style={{ marginLeft: "10px" }}>
                                            {totals &&
                                              totals[`q${quarter.quarter}`] &&
                                              totals[`q${quarter.quarter}`][
                                                "truck"
                                              ] &&
                                              totals[`q${quarter.quarter}`][
                                                "truck"
                                              ]["totalPoints"] &&
                                              formatNumber(
                                                +totals[`q${quarter.quarter}`][
                                                  "truck"
                                                ]["totalPoints"] -
                                                  +totals[
                                                    `q${quarter.quarter}`
                                                  ]["truck"]["slab_jump_points"]
                                              )}
                                          </b>
                                        </div>
                                        <div
                                          style={{
                                            flex: 1,
                                            marginLeft: "20px",
                                          }}
                                        >
                                          Slab Jump Points{" "}
                                          <b>
                                            {totals &&
                                            totals[`q${quarter.quarter}`] &&
                                            totals[`q${quarter.quarter}`][
                                              "truck"
                                            ] &&
                                            totals[`q${quarter.quarter}`][
                                              "truck"
                                            ]["slab_jump_points"]
                                              ? formatNumber(
                                                  totals[`q${quarter.quarter}`][
                                                    "truck"
                                                  ]["slab_jump_points"]
                                                )
                                              : 0}
                                          </b>
                                        </div>
                                      </div>
                                    </div>
                                    {i === 0 &&
                                      quarter.month &&
                                      quarter.month.map((item, monthIndex) =>
                                        currnetMonth === item &&
                                        new Date().getFullYear() <=
                                          this.state.year ? (
                                          <span
                                            className="Till-Date mb-2 mt-0 cardNote"
                                            key={monthIndex}
                                          >
                                            **Current quarter points are
                                            provisional points. They will get
                                            added to the yearly points at the
                                            end of current quarter based on the
                                            achievement of the minimum offtake
                                            criteria of the club.
                                          </span>
                                        ) : (
                                          ""
                                        )
                                      )}
                                    {totals &&
                                    totals[`q${quarter.quarter}`] &&
                                    totals[`q${quarter.quarter}`]["truck"] &&
                                    totals[`q${quarter.quarter}`]["truck"][
                                      "infoMessage"
                                    ] &&
                                    (totals[`q${quarter.quarter}`]["truck"][
                                      "infoMessage"
                                    ] !== null ||
                                      totals[`q${quarter.quarter}`]["truck"][
                                        "infoMessage"
                                      ] !== "") ? (
                                      // <div className="mb-2 mt-0 dangerText">Sorry! You have missed the minimum quarterly offtake target by (30) tyres, and hence not eligible for the quarterly points as per the points earn policy.</div>
                                      <div className="mb-2 mt-0 dangerText">
                                        {
                                          totals[`q${quarter.quarter}`][
                                            "truck"
                                          ]["infoMessage"]
                                        }
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    <Table
                                      className="mb-0 table-responsive tbltruck-bus text-center"
                                      bordered
                                    >
                                      <thead>
                                        <tr
                                          style={{ ...this.getStripedStyle(0) }}
                                        >
                                          {labels &&
                                            labels.points &&
                                            labels.points.map((l, index) => (
                                              <th key={index}>{l.key}</th>
                                            ))}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {quarter.data.report.truck.map(
                                          (item, i) => (
                                            <tr
                                              style={{
                                                ...this.getStripedStyle(i + 1),
                                              }}
                                              key={i}
                                            >
                                              {labels &&
                                                labels.points &&
                                                labels.points.map(
                                                  (l, index) => (
                                                    <td key={index}>
                                                      {l.value === "month"
                                                        ? this.months[
                                                            item[l.value] - 1
                                                          ]
                                                        : formatNumber(
                                                            item[l.value]
                                                          )}
                                                    </td>
                                                  )
                                                )}
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </Table>
                                    <br />

                                    {/* </div> */}
                                  </div>
                                  <div
                                    className="QUARTER-table"
                                    style={{ flex: 1 }}
                                  >
                                    <span
                                      className="mb-1 Total-Offtake mb-2 earnPointTitle"
                                      style={{
                                        marginTop: "25px",
                                        minHeight: totals[
                                          `q${quarter.quarter}`
                                        ]["truck"]["infoMessage"]
                                          ? "60px"
                                          : "auto",
                                      }}
                                    >
                                      <span>Total Offtake</span>&nbsp;
                                      <b>
                                        {totals &&
                                          totals[`q${quarter.quarter}`] &&
                                          totals[`q${quarter.quarter}`][
                                            "truck"
                                          ] &&
                                          totals[`q${quarter.quarter}`][
                                            "truck"
                                          ]["totalOfftake"] &&
                                          formatNumber(
                                            totals[`q${quarter.quarter}`][
                                              "truck"
                                            ]["totalOfftake"]
                                          )}
                                      </b>
                                      {/* <b>{formatNumber(quarter.truckOfftake)}</b> */}
                                      {/* <span style={{ paddingLeft: '15px' }}>Total Eligible Offtake</span>&nbsp;
                                  <b>{
                                    totals && totals[`q${quarter.quarter}`] && totals[`q${quarter.quarter}`]['truck'] && totals[`q${quarter.quarter}`]['truck']['eligibleSales'] &&
                                    formatNumber(totals[`q${quarter.quarter}`]['truck']['eligibleSales'])}</b> */}
                                    </span>
                                    {i === 0 &&
                                      quarter.month &&
                                      quarter.month.map((item, monthIndex) =>
                                        currnetMonth === item &&
                                        new Date().getFullYear() <=
                                          this.state.year ? (
                                          <>
                                            <span className="Till-Date mt-0 cardNote offtakeTableCardNote">
                                              Till{" "}
                                              {moment(new Date()).format(
                                                "DD MMM YYYY"
                                              )}
                                            </span>
                                            <span>&nbsp;</span>
                                          </>
                                        ) : (
                                          ""
                                        )
                                      )}
                                    <Table
                                      className="mb-0 table-responsive tbltruck-bus text-center"
                                      bordered
                                    >
                                      <thead>
                                        <tr
                                          style={{ ...this.getStripedStyle(0) }}
                                        >
                                          {labels &&
                                            labels.offtake &&
                                            labels.offtake.map((l, index) => (
                                              <th key={index}>{l.key}</th>
                                            ))}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {quarter.data.report.truck.map(
                                          (item, i) => (
                                            <tr
                                              key={i}
                                              style={{
                                                ...this.getStripedStyle(i + 1),
                                              }}
                                            >
                                              {labels &&
                                                labels.offtake &&
                                                labels.offtake.map(
                                                  (l, index) => (
                                                    <td key={index}>
                                                      {l.value === "month"
                                                        ? this.months[
                                                            item[l.value] - 1
                                                          ]
                                                        : formatNumber(
                                                            item[l.value]
                                                          )}
                                                    </td>
                                                  )
                                                )}
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </Table>
                                  </div>
                                </div>
                                {i === truckBusPoints.length - 1 && (
                                  <>
                                    <br />
                                    {/* <a href="http://www.jktyrecrm.com" target="_blank">
                          <b className="Learn-more-about" style={{ color: "#495057" }}>
                            {messages.PRIMARY_REPORT.REDIRECT_JK_Baadshah}
                          </b>
                        </a> */}
                                  </>
                                )}
                              </div>
                            </Col>
                          </Row>
                        );
                      })
                    : // <CustomSpinner />
                      ""}
                </TabPane>
              </Tabs>
            </div>
          </>
        )}
      </>
    );
  }
}

export default TruckBusPointsReports;
